module.exports = __webpack_public_path__ + "static/media/Mata Cinta.08e80fe2.jpeg";